import { render, staticRenderFns } from "./productStatus.vue?vue&type=template&id=18e9ede4"
import script from "./productStatus.vue?vue&type=script&lang=js"
export * from "./productStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports